export default __webpack_public_path__ + "static/media/magnesium.89c59f41.jpg";